export const apiCall = async (url, method , body = null) => {
  const token = "ZDJlZjNmZWQyZWVjZWQ1ZjA5NzE5ZjhmZGIyMzM0YzNiMDJlZjFiOTlhMjgzYTFkYWE5MjI4NmJhOTk4YzhmY2FjM2Q1OTFjMzM4NDQ1ODI0MzY2ZTA4YTk5NWVhZDU2";

  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
      "reference":"com.farrther.web",
      "session":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF91c2VyIjoyLCJpZF9yb2wiOjEsInJvbF9uYW1lIjoiYWRtaW5pc3RyYXRvciIsInBpY3R1cmUiOiJodHRwczovL2ZhcnJ0aGVyLWFwaS1zYW5kYm94LnMzLnVzLWVhc3QtMi5hbWF6b25hd3MuY29tL2ZhcnJ0aGVyL2FkbWluL3VzZXJzL3VzZXJzL2U3ZTQ1YTdhLTVkMGEtNGJlOC1hNzJlLTQwYWNkYWIyNmI4NS5qcGVnP1gtQW16LUFsZ29yaXRobT1BV1M0LUhNQUMtU0hBMjU2JlgtQW16LUNvbnRlbnQtU2hhMjU2PVVOU0lHTkVELVBBWUxPQUQmWC1BbXotQ3JlZGVudGlhbD1BS0lBNkdCTURXUVRMTkQ1QlhLTiUyRjIwMjYwMjEyJTJGdXMtZWFzdC0yJTJGczMlMkZhd3M0X3JlcXVlc3QmWC1BbXotRGF0ZT0yMDI2MDIxMlQwNDU2MjVaJlgtQW16LUV4cGlyZXM9OTAwJlgtQW16LVNpZ25hdHVyZT1lNmExOGRhNGVjYzljNGI5ZTQ2NzI0NTY4NWRlY2M4NDY0NjVkYWMxYjcwZjA2YmYwYTYzMTQ2Nzc3YjFjM2MzJlgtQW16LVNpZ25lZEhlYWRlcnM9aG9zdCZ4LWlkPUdldE9iamVjdCIsInVzZXJuYW1lIjoidXNlci50ZXN0IiwiZmlyc3RfbmFtZSI6Ik1vbm9jaWxpbmRyZXJvIiwibGFzdF9uYW1lIjoiVGVzdCIsInBob25lIjoiNTU3NDA0MDQ3MSIsImVtYWlsIjoiaG9sYUBtb25vY2lsaW5kcmVyby5jb20iLCJpYXQiOjE3NzA4NzIxODUsImV4cCI6MTc3MDkwODE4NX0.XDB3rLaao30tE6Pz7jcOMDZiJwmVo7tM-fLSevKuiMw"
      },
      body: body ? JSON.stringify(body) : null
    });

    const data = await response.json();

    return {
      ok: response.ok,
      status: response.status,
      data
    };

  } catch (error) {
    return {
      ok: false,
      status: 500,
      data: { message: "Network error" }
    };
  }
};
